import { render, staticRenderFns } from "./ReturnReportingMaterials.vue?vue&type=template&id=5c323f84&scoped=true"
import script from "./ReturnReportingMaterials.vue?vue&type=script&lang=js"
export * from "./ReturnReportingMaterials.vue?vue&type=script&lang=js"
import style0 from "./ReturnReportingMaterials.vue?vue&type=style&index=0&id=5c323f84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c323f84",
  null
  
)

export default component.exports